var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoSoundFilled = function SvgNoSoundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.658 4.792V15.2a1.04 1.04 0 0 1-1.666.833l-4.4-3.325H2.483a1.042 1.042 0 0 1-1.041-1.041V8.333c0-.575.466-1.041 1.041-1.041h2.109l4.4-3.325a1.035 1.035 0 0 1 1.091-.1c.359.175.575.533.575.933v-.008ZM16.3 10l2.058-2.058a.629.629 0 0 0 0-.884.629.629 0 0 0-.883 0l-2.058 2.059-2.059-2.059a.629.629 0 0 0-.883 0 .629.629 0 0 0 0 .884L14.533 10l-2.058 2.058a.629.629 0 0 0 0 .884.618.618 0 0 0 .442.183.618.618 0 0 0 .441-.183l2.059-2.059 2.058 2.059a.618.618 0 0 0 .442.183.618.618 0 0 0 .441-.183.629.629 0 0 0 0-.884L16.3 10Z",
    fill: "current"
  })));
};
export default SvgNoSoundFilled;